import React from 'react';
import ScrollReveal from './ScrollReveal';
import { useLanguage } from '../LanguageContext';

const INSTAGRAM_REEL_URL = 'https://www.instagram.com/reel/DdOiD3eMQdM/embed/';
const INSTAGRAM_POST_URL = 'https://www.instagram.com/p/DdOiD3eMQdM/';

const InstagramVideo: React.FC = () => {
  const { language } = useLanguage();
  const isHindi = language === 'hi';

  return (
    <section id="video" className="scroll-mt-24 bg-[var(--color-cream)] pb-16 md:pb-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ScrollReveal className="mx-auto max-w-2xl text-center">
          <h2 className="section-title !mt-0 text-[var(--color-ink)]">
            {isHindi ? 'दूध की कहानी को काम करते हुए देखें' : 'See the story in action'}
          </h2>
          <p className="section-copy mx-auto">
            {isHindi
              ? 'डेमो के बाद, हर दूध डिलीवरी के पीछे होने वाले काम को देखने के लिए यह वीडियो देखें।'
              : 'After the Demo, watch this video to see the work that goes behind every milk delivery.'}
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delayMs={120} className="mx-auto mt-10 max-w-[460px]">
          <div className="overflow-hidden rounded-[2rem] border border-[rgba(27,94,32,0.12)] bg-[#17251a] p-2 shadow-[0_24px_70px_rgba(27,94,32,0.18)]">
            <div className="aspect-[9/16] overflow-hidden rounded-[1.5rem] bg-black">
              <iframe
                title={isHindi ? 'Rightoz इंस्टाग्राम वीडियो' : 'Rightoz Instagram video'}
                src={INSTAGRAM_REEL_URL}
                loading="lazy"
                className="h-full w-full border-0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              />
            </div>
          </div>
          <a
            href={INSTAGRAM_POST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex w-full justify-center text-sm font-semibold text-[var(--color-forest)] transition hover:text-[var(--color-leaf)]"
          >
            {isHindi ? 'और जानने के लिए Instagram पर फ़ॉलो करें' : 'Follow us on Instagram to know more'}
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default InstagramVideo;
